import React, { createContext } from "react";

export const LocaleContext = createContext<any>(undefined);

export const LocaleContextProvider = (props: any) => {
    let language = (typeof navigator !== 'undefined' && navigator.language) ? navigator.language.split(/[-_]/)[0] : 'en';  // language without region code
    if (language != 'fr' && language != 'en') {
        language = 'en'
    }
    const [locale, setLocale] = React.useState(language);
    return (
        <LocaleContext.Provider value={[locale, setLocale]}>
            {props.children}
        </LocaleContext.Provider>
    );
};
